import { Controller } from '@hotwired/stimulus'
import Vlitejs from 'vlitejs'
import YouTube from 'vlitejs/providers/youtube.js'

Vlitejs.registerProvider('youtube', YouTube)

export default class extends Controller {
  static targets = ['player']

  static values = {
    poster: String,
    provider: String,
    start: Number,
    end: Number
  }

  connect () {
    this.init()
  }

  init () {
    if (!this.hasPlayerTarget) return

    this.player = new Vlitejs(this.playerTarget, this.options)
  }

  play () {
    this.player?.player?.play()
  }

  pause () {
    this.player?.player?.pause()
  }

  get options () {
    return {
      provider: ["youtube"],
      options: {
        controls: true,
        autoplay: false,
        playPause: true,
        progressBar: false,
        time: false,
        volume: true,
        fullscreen: true,
        poster: this.posterValue,
        providerParams: {
          start: this.startValue,
          end: this.endValue,
          rel: 0,
          disablekb: 1,
          cc_load_policy: 1
        },
      },
      onReady: (player) => {
        // This resets the video after ended
        player.on("ended", () => {
          player.pause();
          player.seekTo(this.startValue)
        });
      },
    }
  }
}
